import React from 'react';
import axios from 'axios';

import * as Globals from './../Globals';


export default class MaterialView extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
            name: "",
            documents: [],
            videos: []
		}
	}

    componentDidMount() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.BASE_PATH + 'api/subjects/' + this.props.id,
		{
			headers: {
				'Accept': 'application/json',
				'Access-Control-Allow-Origin': '*',
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + cookie
			}
		}).then(response => {
			this.setState({
				name: response.data.name
			});
		}).catch((error) => {
			this.props.CheckAuthError(error);
        });
        axios.get(Globals.EL_PATH + 'subject/' + this.props.id + '/document?Authentication=' + cookie
        ).then(response => {
			this.setState({
				documents: response.data.records
			});
		}).catch((error) => {
			this.props.CheckAuthError(error);
        });
        axios.get(Globals.EL_PATH + 'subject/' + this.props.id + '/video?Authentication=' + cookie
        ).then(response => {
			this.setState({
				videos: response.data.records
			});
		}).catch((error) => {
			this.props.CheckAuthError(error);
		});
	}

    getDocuments() {
        if (this.state.documents.length > 0) {
            return (
                <ul>
                    {
                        this.state.documents.map( (document, index) =>
                            <li key={index}><a download href={ document.source } target="_blank">{ document.source.split("/")[ document.source.split("/").length - 1] }</a></li>
                        )
                    }
                </ul>
            );
        }
        else {
            return ( <p className="text-muted">Keine Dokumente gefunden</p> );
        }
    }

    getVideos() {
        if (this.state.videos.length > 0) {
            return (
                <div>
                    {
                        this.state.videos.map( (video) =>
                            <div className="fluid-media">
                                <iframe type="text/html" src={ video.source } title={video.source}
                                frameborder="0" allow="encrypted-media" allowFullScreen/>
                            </div>
                        )
                    }
                </div>
            );
        }
        else {
            return ( <p className="text-muted">Keine Videos gefunden</p> );
        }
    }

    render(){
		return (
            <div className="container">
                <div className="panel panel-default userLearningMaterial">
                    <div className="panel-heading text-center"><h3>Lernmaterial für { this.state.name }</h3></div>
                    <ul className="list-group-material">
                        <li className="list-group-data">
                            <h4>Dokumente</h4>
                            { this.getDocuments() }
                        </li>
                        <li className="list-group-data">
                            <h4>Videos</h4>
                            { this.getVideos() }
                        </li>
                    </ul>
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/user/MaterialView.js